require('./lbaSpacer.scss');

const $inject = [];
const lbaSpacer = function () {
  return {
    restrict: 'A',
    scope: {
      settings: '<'
    },
    template: require('./lbaSpacer.html'),
    link: function(scope, element) {
      const hr = element.find('hr');
      if (scope.settings && scope.settings.color) {
        hr.css({
          'background': scope.settings.color,
          'height': '1px',
          'border': '0',
          'box-shadow': 'none'
        });
      }
    }
  }
};

lbaSpacer.$inject = $inject;
export default lbaSpacer;



// WEBPACK FOOTER //
// ./src/components/lbaSpacer/lbaSpacerDir.js